class RelatedVideos extends HTMLElement {
  connectedCallback() {
    onLibReady(['vue', 'swiper'], this.#init.bind(this));
  }

  async #init() {
    let videos = [];

    if (this.dataset.videos) {
      videos.push(...this.dataset.videos.split(','));
    }

    if (Shopify.collectionHandle && Shopify.template === 'collection') {
      const collection = await this.#fetchCollection({handle: Shopify.collectionHandle});
      collection.products
        .filter(product => product.main_collection === Shopify.collectionHandle)
        .forEach(product => product.videos && videos.push(...product.videos.split('|')));
    }

    videos = [...new Set(videos)].filter(video => video).map(video => ({url: video, title: ''}));

    const title = this.dataset.title;

    if (!videos.length) {
      return;
    }

    new Vue({
      el: this,
      data: {
        videos,
        title,
      },
      template: `
        <div class="related-videos section" v-if="videos.length">
          <div class="page-width">
            <h2 class="section-title">{{ title }}</h2>
          </div>

          <div class="page-width-plus">
            <div class="related-videos__slider">
              <div class="page-width">
                <div class="swiper-container" ref="slider">
                  <div class="swiper-wrapper">
                    <template v-for="(video, index) in videos">
                      <div class="swiper-slide" :key="index">
                        <a data-fancybox="video-gallery" :data-src="video.url" target="_blank" class="related-videos__item" :aria-label="video.title">
                          <span class="related-videos__item-image">
                            <img 
                              :srcset="getYouTubeUrlImage(video.url)" 
                              src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                              loading="lazy"
                              :alt="video.title"
                            >
                            
                            <span class="related-videos__item-play">
                              <svg class="icon svg-icon" width="28" height="33" viewBox="0 0 28 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                \t<path d="M26.5 13.9019C28.5 15.0566 28.5 17.9434 26.5 19.0981L4.74999 31.6554C2.74999 32.8101 0.249998 31.3668 0.249999 29.0574L0.25 3.94263C0.25 1.63323 2.75 0.189853 4.75 1.34455L26.5 13.9019Z" fill="white"/>
                              </svg>
                            </span>
                          </span>
                          
                          <div class="related-videos__item-title">{{ video.title }}</div>
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <div class="slider-button-prev" ref="sliderBtnPrev">
                <div class="icon-arrow circle icon-arrow-prev">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve">
                    <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
                    c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
                    C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
                    C255,161.018,253.42,157.202,250.606,154.389z"/>
                  </svg>
                </div>
              </div>
              <div class="slider-button-next" ref="sliderBtnNext">
              <div class="icon-arrow circle icon-arrow-next">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve">
                    <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
                    c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
                    C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
                    C255,161.018,253.42,157.202,250.606,154.389z"/>
                  </svg>
                </div>
              </div>
              
              <div class="slider-dots circle" ref="sliderDots"></div>
            </div>
          </div>
        </div>
      `,

      async mounted() {
        await this.getVideoTitles();
        this.videos = videos.filter(video => video.title);
        this.videos.length > 1 && this.initSlider();
      },

      methods: {
        getVideoId(url) {
          if (!url) return;
          const splitUrl = url.split('.be/');

          return splitUrl[splitUrl.length - 1];
        },

        getYouTubeUrlImage(url) {
          if (!url) return;
          return `http://img.youtube.com/vi/${this.getVideoId(url)}/mqdefault.jpg`;
        },

        async getVideoTitles() {
          const apiUrl = 'https://www.googleapis.com/youtube/v3/videos';
          const apiKey = 'AIzaSyCsjlPJmKBtpPZ5ApDxRRWSupj-Ofja6ys';
          const urls = [];
          this.videos.forEach(video => {
            urls.push(this.getVideoId(video.url));
          });

          const response = await fetch(
            `${apiUrl}?id=${urls.slice(0, 50).join(',')}&key=${apiKey}&fields=items(id,snippet(title))&part=snippet`,
          ).then(response => response.json());
          if (response.items?.length) {
            response.items.forEach(item => {
              this.videos.some(video => {
                if (video.url.includes(item.id)) {
                  video.title = item.snippet.title;
                  return true;
                }
              });
            });
          }
        },

        initSlider() {
          this.slider = new Swiper(this.$refs.slider, {
            slidesPerView: 1,
            spaceBetween: 20,
            observer: true,
            watchOverflow: true,
            breakpoints: {
              750: {
                slidesPerView: 2.4,
              },
              990: {
                slidesPerView: window.Shopify.template === 'product' ? 2 : 3,
              },
            },
            navigation: {
              nextEl: this.$refs.sliderBtnNext,
              prevEl: this.$refs.sliderBtnPrev,
            },
            pagination: {
              el: this.$refs.sliderDots,
              type: 'bullets',
              clickable: true,
            },
          });
        },
      },
    });
  }

  async #fetchCollection({handle, page = 1}) {
    const response = await fetch(`/collections/${handle}?view=json&page=${page}`).then(response => response.json());

    if (response) {
      let collection = null;

      if (response.next_page) {
        const urlParams = new URLSearchParams(response.next_page.url.split('?')[1]);
        collection = await this.#fetchCollection({handle: handle, page: urlParams.get('page')});
      }

      if (collection) {
        response.products.push(...collection.products);
      }

      return response;
    }
  }
}

customElements.define('related-videos', RelatedVideos);
